import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetActivity } from './activityThunk';
import { IActivity } from '~/utils/interface/activity';
import { ROWS_PER_PAGE } from '~/utils/constants/common';

export interface ActivityState {
  activityList: Array<IActivity>;
  activityListContact: Array<IActivity>;
  activityListContactOrganization: Array<IActivity>;
  filter: IActivityFilter;
  needRefreshData: boolean;
  currentPage: number;
  totalPages: number;
}

interface IActivityFilter {
  page: number;
  limit?: number;
  groupType: string | number;
  groupId: string | number;
}

const initialState: ActivityState = {
  activityList: [],
  activityListContactOrganization: [],
  activityListContact: [],
  currentPage: 0,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    groupType: '',
    groupId: '',
  },
};

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    setFilterActivity(state, action: PayloadAction<IActivityFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(handleGetActivity.fulfilled, (state, action) => {
      if (state.filter.page === 1) {
        state.activityList = [...action.payload.responses];
      } else {
        state.activityList = [...state.activityList, ...action.payload.responses];
      }
      state.needRefreshData = false;
    });
  },
});

export const activityActions = activitySlice.actions;

const activityReducer = activitySlice.reducer;
export default activityReducer;
